module.exports = __webpack_public_path__ + "img/logo.b9088704.png";